import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { TranslationService } from '../../common/services/translation.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { NgForm } from '@angular/forms';
import { ChangeSet } from '../../common/models/ChangeSet.model';
import { CpqToastrService } from '../../cpq-toastr/cpq-toastr.service';

@Component({
    selector: 'cpq-cpq-add-new-change-set-dialog',
    templateUrl: './cpq-add-new-change-set-dialog.component.html',
    styleUrls: ['./cpq-add-new-change-set-dialog.component.scss'],
    standalone: false
})
export class CpqAddNewChangeSetDialogComponent implements OnInit {
  @ViewChild('form', { static: true }) form: NgForm;
  public model: ChangeSet;

  constructor(private translationService: TranslationService,
    private toastr: CpqToastrService, 
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeSet) { }

  ngOnInit() {
    this.model = this.data;
  }

  public save() {
    if (this.model.name) {
      this.dialogRef.close(this.model);
    } else {
      this.toastr.error(this.translationService.translate('ActionsEdit.NameRequired'));
    }
  }

  public close() {
    this.dialogRef.close(null);
  }
}
